import React from 'react';
import { stats } from '../data/landing';
export function StatsBand() {
  return <section aria-labelledby="stats-title" className="border-b border-stone-200 bg-white" data-id="element-172" data-mp="21b6867vh5nxz">
      <div className="mx-auto max-w-6xl px-5 py-12 lg:py-14" data-id="element-173" data-mp="1wc30efo413mb">
        <h2 id="stats-title" className="text-center text-[11px] font-bold uppercase tracking-[0.2em] text-brand" data-id="element-174" data-mp="1wcl41xd3qk49">
          <span aria-hidden="true" data-id="element-175" data-mp="1ravs8fi222f4">📊 </span>Todo lo que recibís en un solo pack
        </h2>

        <dl className="mt-9 grid grid-cols-2 gap-y-9 sm:grid-cols-4" data-id="element-176" data-mp="2ozz5a7nu21u6">
          {stats.map(stat => <div key={stat.label} className="flex flex-col items-center gap-2 px-3 text-center sm:border-r sm:border-stone-200 sm:last:border-r-0" data-id="element-177" data-mp="2k272gilngvb7">
              <dd className="font-serif text-3xl font-black leading-none text-stone-900 sm:text-4xl" data-id="element-178" data-mp="2a3q7zbni5yke">{stat.value}</dd>
              <dt className="text-[11px] font-bold uppercase leading-snug tracking-[0.14em] text-stone-600" data-id="element-179" data-mp="13nny8tq2ufse">{stat.label}</dt>
            </div>)}
        </dl>
      </div>
    </section>;
}